import styles from './SearchBar.module.css';
import { useSharedState } from '../hooks/useSharedState';
import { useEffect, useState } from 'react';
import magnifier from '../assets/magnifier.png';

interface SearchBarProps {
    
}

const SearchBar : React.FC<SearchBarProps> = ({}: SearchBarProps) => {

    const [query, setQuery] = useSharedState('searchQuery', '');
    const [_query, _setQuery] = useState(query);

    useEffect(() => {
        _setQuery(query);
    }, [query]);

    const handleInputChange = (e: any) => {
        _setQuery(e.target.value);
    };
    
    const handleSubmit = (e: any) => {
        e.preventDefault();
        const trimmedQuery = _query.trim();
        setQuery(trimmedQuery);
    };

    const handleKeyDown = (e: React.KeyboardEvent) => {
        if(e.key == 'Enter') {    
            handleSubmit(e);
        }
    }

    return <div>
        <form className={styles.searchBar} onSubmit={handleSubmit}>
            <input
                type="text"
                className={styles.searchInput}
                placeholder="Rechercher un événement"
                value={_query}
                onChange={handleInputChange}
                onKeyDown={handleKeyDown}
            />

            {_query && (
                <button
                    type="button"
                    className={styles.clearButton}
                    onClick={() => { _setQuery(''); setQuery(''); }}
                    aria-label="Effacer la recherche"
                    title="Effacer la recherche"
                >×</button>
            )}

            <button type="submit" className={styles.searchButton} aria-label="Lancer la recherche" title="Lancer la recherche">
                <img src={magnifier} alt="Lancer la recherche"/>
            </button>
        </form>
    </div>;
};


export default SearchBar;